<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <v-text-field
      v-model="additionalInfo"
      label="Informacje dodatkowe"
      outlined
      hint="Wskaż dodatkowe informacje dotyczące zlecenia serwisu (np. numery wagonów)"
      persistent-hint
    ></v-text-field>

    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';

export default {
  name: 'TrainCleaning',
  components: {
    DialogSaveButton,
  },
  props: {
    entity: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      additionalInfo: null,
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      this.additionalInfo = this.entity.additionalInfo;
    } else if (this.isTrainCleaningAdded) {
      const service = this.$store.getters['service/services'].find(
        ({ serviceType }) => serviceType === SERVICE_TYPE_DICT.TRAIN_CLEANING
      );
      this.additionalInfo = service.additionalInfo;
    }
  },
  computed: {
    ...mapGetters('service', ['isTrainCleaningAdded']),
  },
  methods: {
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: SERVICE_TYPE_DICT.TRAIN_CLEANING,
          additionalInfo: this.additionalInfo,
        };

        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isTrainCleaningAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
